var map = {
	"./fiskerikajen/app-icon.png": "c5c1",
	"./fiskidag/app-icon.png": "d7d4",
	"./fsg/app-icon.png": "640f",
	"./kvalitetsfisk/app-icon.png": "5dde"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1d34";